import { render, staticRenderFns } from "./confirmation.vue?vue&type=template&id=4bd88a2e"
import script from "./confirmation.vue?vue&type=script&lang=js"
export * from "./confirmation.vue?vue&type=script&lang=js"
import style0 from "./confirmation.vue?vue&type=style&index=0&id=4bd88a2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports